const CSS_VAR_NAME = /var\(\s*(--[\w-]+)/;

export const resolveCssVar = (value) => {
  if (typeof value !== "string" || typeof window === "undefined") {
    return value;
  }
  const match = CSS_VAR_NAME.exec(value);
  if (!match) {
    return value;
  }
  const resolved = window
    .getComputedStyle(document.body)
    .getPropertyValue(match[1])
    .trim();
  return resolved || value;
};
